export default (
  priceValue: number,
  currency: string = "EUR",
  locale: string = "fr-FR"
): string => {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    priceValue / 100
  );
};
